import { FormikProps, getIn } from "formik";
import { FC } from "react";

export interface UpdatePointRedemptionFormValues {
  status: string;
  redemptionId: string;
}

export interface UpdatePointRedemptionFormProps {
  form: FormikProps<UpdatePointRedemptionFormValues>;
}

const STATUS_OPTIONS = [
  { value: "RECEIVED", label: "Received" },
  { value: "PENDING", label: "Pending" },
  { value: "IN-PROGRESS", label: "In Progress" },
];

const UpdatePointRedemptionForm: FC<UpdatePointRedemptionFormProps> = ({
  form,
}) => {
  const getFieldError = (fieldName: string) => {
    const touched = getIn(form.touched, fieldName);
    const error = getIn(form.errors, fieldName);
    return touched && error ? error : null;
  };

  return (
    <div className="space-y-4">
      <div
        className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded mb-4"
        role="alert"
      >
        <div className="font-bold">Redemption Status Update</div>
        <p>
          You can change the redemption status to Received, Pending, or In
          Progress.
        </p>
        <p className="mt-2 italic text-sm">
          This action will notify the user about the status change.
        </p>
      </div>

      <div className="space-y-1">
        <label
          htmlFor="status"
          className="block text-sm font-medium text-gray-700"
        >
          Status
        </label>
        <div className="mt-1">
          <select
            id="status"
            name="status"
            value={form.values.status}
            onChange={form.handleChange}
            onBlur={form.handleBlur}
            className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
          >
            <option value="">Select a status</option>
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {getFieldError("status") && (
            <p className="mt-2 text-sm text-red-600">
              {getFieldError("status")}
            </p>
          )}
        </div>
      </div>

    
    </div>
  );
};

export default UpdatePointRedemptionForm;
